/**
 * This function defines, from the layerService and the paermalink parameter
 * which is/must be the current base layer to display on the map.
 * It avoids duplication of code.
 */
function getCurrentBaseLayer(baseLayers, baseLayerParam) {
  if (baseLayerParam) {
    const baseLayer = baseLayers.find((l) => {
      return l.key === baseLayerParam;
    });
    if (baseLayer) {
      // If the base layer in the url exists, make it visible.
      baseLayer.setVisible(true);
    }
  }

  if (
    !baseLayers.filter((layer) => {
      return layer.getVisible();
    }).length
  ) {
    // If no base layer are visible, set the first one as visible.

    baseLayers[0].setVisible(true);
  }
  const currentBaseLayer = baseLayers.find((layer) => {
    return layer.getVisible();
  });
  return currentBaseLayer;
}

export default getCurrentBaseLayer;
